function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "camera-solid",
  d: "M18.286,36V46.286A1.715,1.715,0,0,1,16.571,48H1.714A1.715,1.715,0,0,1,0,46.286V36a1.715,1.715,0,0,1,1.714-1.714H4.857L5.3,33.111A1.712,1.712,0,0,1,6.9,32h4.482a1.712,1.712,0,0,1,1.6,1.111l.443,1.175h3.143A1.715,1.715,0,0,1,18.286,36Zm-4.857,5.143a4.286,4.286,0,1,0-4.286,4.286A4.289,4.289,0,0,0,13.429,41.143Zm-1.143,0A3.143,3.143,0,1,1,9.143,38,3.147,3.147,0,0,1,12.286,41.143Z",
  transform: "translate(0 -32)",
  fill: "#333"
});

function SvgCameraSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.286,
    height: 16,
    viewBox: "0 0 18.286 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraSolid);
export default __webpack_public_path__ + "static/media/camera-solid.9ae0183e.svg";
export { ForwardRef as ReactComponent };